import { IconProps } from '@repo/core/global-data/dataInterface.data';


const AddClient = ({ width = '20', height = '20', className = '' }: IconProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 21 20" fill="none" className={className} xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.5163 1.8832L16.9413 4.8082C17.5747 5.14987 17.5747 6.12487 16.9413 6.46654L11.5163 9.39154C11.033 9.64987 10.4663 9.64987 9.98301 9.39154L4.55801 6.46654C3.92467 6.12487 3.92467 5.14987 4.55801 4.8082L9.98301 1.8832C10.4663 1.62487 11.033 1.62487 11.5163 1.8832Z"
        stroke="#FFFFFF"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.75866 8.44173L8.80033 10.9667C9.42533 11.2834 9.82533 11.9251 9.82533 12.6251V17.3917C9.82533 18.0834 9.10033 18.5251 8.48366 18.2167L3.44199 15.6917C2.81699 15.3751 2.41699 14.7334 2.41699 14.0334V9.26673C2.41699 8.57506 3.14199 8.1334 3.75866 8.44173Z"
        stroke="#FFFFFF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.7415 8.44173L12.6998 10.9667C12.0748 11.2834 11.6748 11.9251 11.6748 12.6251V17.3917C11.6748 18.0834 12.3998 18.5251 13.0165 18.2167L18.0581 15.6917C18.6831 15.3751 19.0831 14.7334 19.0831 14.0334V9.26673C19.0831 8.57506 18.3581 8.1334 17.7415 8.44173Z"
        stroke="#FFFFFF"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default AddClient;
